import {inject, Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService {

  private router = inject(Router);
  private auth = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.auth.isUserLogged())
    {
      return true;
    }
    else{
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('factorial_identifier');
      this.router.navigate(['/login']);
      return false;
    }
  }
}
